import { render } from "./Page-Portfolio.vue?vue&type=template&id=19729ab9&scoped=true"
import script from "./Page-Portfolio.vue?vue&type=script&lang=js"
export * from "./Page-Portfolio.vue?vue&type=script&lang=js"

import "./Page-Portfolio.vue?vue&type=style&index=0&id=19729ab9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19729ab9"

export default script